import type { DeprecatedButtonTokens } from '../types';

export const deprecatedButton: DeprecatedButtonTokens = {
  colors: {
    darkButtonTextColor: 'blue.50',
    lightButtonBgColor: 'brandPrimary.0',
  },
};
